import styled from 'styled-components';

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	&:before {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		width: 10px;
		height: 300px;
		border-radius: 50%;
		box-shadow: 20px 0 50px #707070;
	}
	.inner-form {
		background-color: #fff;
		padding: 30px 42px 33px 36px;
		height: 375px;
		width: 333px;
		flex: 0 0 333px;
		position: relative;
		border-right: 1px solid #e5e5e5;
	}
	h2 {
		font-size: 20px;
		line-height: 30px;
		margin-bottom: 15px;
	}
	.recharge-options {
		display: flex;
		align-items: center;
		gap: 43px;
		margin-bottom: 9px;
		.radio {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}
	.form-field {
		margin-bottom: 6px;
		input[type='text'],
		.date,
		.item-select {
			height: 44px;
			font-size: 13px;
			font-weight: 500;
			color: #141414;
			width: 100%;
			border: none;
			box-shadow: 0 1px 0 #dfdfdf;
			outline: none;
			&::placeholder {
				color: #141414;
			}
		}
		.hide {
			display: none;
		}
	}
	.browse-plans {
		font-weight: 500;
		font-size: 12px;
		margin: 18px 0 24px;
		text-decoration: underline;
		color: #00baf2;
		font-weight: bold;
		cursor: pointer;
	}
	.button-outline {
		width: 100%;
	}
`;

export const PlanWrapper = styled.div`
	background-color: #fff;
	/* padding: 30px 42px 33px 36px; */
	height: 375px;
	position: relative;
	flex: 1;
	.plan-tabs-wrapper {
		display: flex;
		overflow-x: auto;
		.plan-tab {
			padding: 10px 30px;
			border-top: 4px solid #fff;
			color: #888;
			text-transform: capitalize;
			margin-bottom: 30px;
			flex: 0 0 180px;
			text-align: center;
			cursor: pointer;
			&.active {
				box-shadow: 0 0 5px #bdbdbd;
				border-top-color: #00baf2;
				color: #141414;
			}
		}
	}
	.plan-details-wrapper {
		max-height: 255px;
		overflow-y: auto;
		.details {
			display: flex;
			padding-bottom: 10px;
			border-bottom: 1px dashed #e5e5e5;
			margin-bottom: 30px;
			> div {
				flex: 0 0 25%;
				strong {
					font-size: 18px;
					font-weight: 500;
					display: inline-block;
					vertical-align: top;
				}
				span {
					color: #888;
					display: block;
				}
				&.select-link {
					text-align: right;
					strong {
						color: #00baf2;
						border: 2px solid #00baf2;
						padding: 5px 15px;
						text-align: center;
						min-width: 100px;
						border-radius: 2px;
						white-space: nowrap;
					}
				}
			}
		}
	}
`;

 
export const Qrwrapper = styled.div`
 h2{
		text-align: center;
	}
.qr-box{
	width: 250px;
		height: 250px;
		margin-inline: auto;
	img{
		width: 100%;
		height: 100%;
		display: block;
		margin-inline: auto;
	}
	
	
}
`;

 export const QeWrapper = styled.div`
 justify-content: center;
 align-items: center;
 position: fixed;
 left: 0;
 top: 0;
 background-color: #0000008c;
 width: 100%;
 height: 100%;
 z-index: 1;


 &>div{

	background-color: #f6f6f6;
	margin: 20px;
	border-radius: 20px;
	position: relative;
overflow: auto;
	max-height: calc(100% - 40px);
	width: 100%;
	max-width: 400px;
	
	.bottom{
	width: 100%;
	height: 30px;
	position: sticky;
	bottom: 0;
	background-color: #f6f6f6;
	z-index: 111;
 }
	&::-webkit-scrollbar{
		width: 0;
	}
	.header{
		position: sticky;
		top: 0;
		background-color: #f6f6f6;
		z-index: 1111;
		gap: 20px;
		padding:  20px 30px 4px;
		.close{
		width: 24px;
	
	  margin-left: auto;
	  cursor: pointer;

	}
	}
	
	.maiBox{
		
		height: 100%;
		padding: 0px 40px;
		max-width: 400px;
		width: 100%;
		font-family: 'Poppins', sans-serif;
		h3{
			margin-bottom: 20px;
			font-size: 14px;
		}
	}
 }
 .left-box {
margin-bottom: 10px;
	.img{
	max-width: 200px;
	padding: 0px;
	border-radius: 10px;

	background: #FFFFFF;
box-shadow: 0px 1px 2px #0000000D;
border: 1px solid #EAEAEA;
position: relative;
 margin-inline: auto;
 overflow: hidden;
gap: 10px;
img.logoImg{
	
	position: absolute;
    left: 50%;
    top: 50%;
    width: 40px;
    height: 40px;
	border-radius: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
	filter: grayscale(1);
	padding: 2px;
	background-color: #fff;
	
}
	z-index: 11;
}
.timerBox{
	gap: 10px;
	font-size: 10px;
	justify-content: center;
	padding-top: 10px;
}
.timer{
	/* position: absolute;
	bottom: 9px;
	left: 50%; */
	color: green;
	font-weight: 600;
	font-size: 10px;
}

img{
	width: 100%;
}


}
 .middle{
	border-left: 1px dashed #1E437A;
 }
 .right-box{
	
	
	&> img{
		max-width: 180px;
	}
	margin-bottom: 40px;
	

	h3{
		font: normal normal medium 20px/30px;
		margin-bottom: 25px;
	}
	p{
		font: normal normal medium 13px/20px;
		margin-bottom: 12px;
	}
	a{
		width: 100%!important;
		max-width: 220px;
		margin-top: 14px;
	}
 }
 .left-box{
	h2,h3{
		
		text-align: center;
	}
	a{
		
	}
	
 }
 /* HTML: <div class="loader"></div> */
.loaderPending {
  height: 14px;
  width: 50px;
  margin-inline: auto;
  border-radius: 20px;
  --c:no-repeat linear-gradient(#6100ee 0 0);
  background: var(--c),var(--c),#d7b8fc;
  background-size: 60% 100%;
  animation: l16 3s infinite;
}
@keyframes l16 {
  0%   {background-position:-150% 0,-150% 0}
  66%  {background-position: 250% 0,-150% 0}
  100% {background-position: 250% 0, 250% 0}
}
 
 @media screen and (max-width: 992px)  {


	&>div{
		max-height: calc(100vh - 40px);
		overflow: auto;
		&::-webkit-scrollbar{
			width: 0;
		}
		&> div{
		flex-direction: column;
		align-items: center;
	}
	}
	 
	.left-box{
	h2,h3{
		display: block;
		
	}

 }
 .right-box{
	h2,h3{
       display: none;
	}
	p{
		margin-top: 10px;
	}
 }
 }
`;